import { render, staticRenderFns } from "./TemplateSearch.vue?vue&type=template&id=1687c5bf&scoped=true&"
import script from "./TemplateSearch.vue?vue&type=script&lang=js&"
export * from "./TemplateSearch.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSearch.vue?vue&type=style&index=0&id=1687c5bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1687c5bf",
  null
  
)

export default component.exports